// Week 7 / Day 4 — Команда, роли и качество / Team, Roles and Quality
// Solid Grade 6 math + RU Grade 3–4.

export const maxWeek7Day4 = {
  id: 'max-week-7-day-4',
  studentId: 'max',
  weekId: 'week-7',
  dayId: 'day-4',
  title: 'Команда, роли и качество / Team, Roles and Quality',
  shortTitle: 'Команда и качество / Team and Quality',
  theme:
    'Макс анализирует командную работу, роли, качество и проверку ошибок. / Max analyses team work, roles, quality and error checking.',
  estimatedTimeLabel: 'Онлайн: 25–35 мин. Полный день: 80–100 мин. / Online: 25–35 min. Full day: 80–100 min.',
  nimnyIntro:
    'Нимни ведёт Макса через дроби ролей, индекс качества, проверку 75% ошибок и уравнение с ролями. / Nimny walks Max through role fractions, quality index, 75% error check and a role equation.',
  goals: [
    'Слой 1. Математика / Layer 1. Math: дроби 1/4 и 1/3 от целого, среднее/медиана/размах, процент от количества, уравнения (Grade 6). / fractions, mean/median/range, percent, equations.',
    'Слой 2. Русский / Layer 2. Russian: части речи, безударные, исправление.',
    'Слой 3. Чтение и письмо / Layer 3. Reading: короткий текст о команде + план + 4 предложения.',
    'Слой 4. Логика и анализ данных / Layer 4. Logic and data analysis: меньше задач ≠ хуже помощь.',
    'Слой 5. Практика: карточка команды из 3 ролей. / Practical: team card with 3 roles.',
    'Дневник мышления / Thinking Diary.',
    'Награда нимами / Reward in nims: 3/5.'
  ],
  vocabulary: [
    { term: 'команда / team', definition: 'группа людей с общей целью / a group with a shared goal' },
    { term: 'роль / role', definition: 'что делает один участник команды / one member’s function' },
    { term: 'дизайнер / designer', definition: 'тот, кто оформляет проект / one who shapes the design' },
    { term: 'мастер / master', definition: 'тот, кто делает основную работу / one who does the main work' },
    { term: 'редактор / editor', definition: 'тот, кто проверяет ошибки / one who checks errors' },
    { term: 'индекс качества / quality index', definition: 'среднее оценок работы / mean of quality scores' }
  ],
  onlineTasks: [
    { id: 'q1', type: 'math', title: 'Роли в команде / Team roles',
      prompt: 'В команде 48 задач. 1/4 — дизайнер, 1/3 — мастер, остальные — редактор. Сколько у редактора? / 1/4 designer + 1/3 master; rest editor.',
      helper: '1/4 от 48 и 1/3 от 48. / Fractions.',
      answer: '20 задач у редактора. / 20 tasks.', unit: 'задач / tasks' },
    { id: 'q2', type: 'math', title: 'Индекс качества / Quality index',
      prompt: 'Оценки 5 работ: 7.5, 8, 9, 6.5, 9. Найди среднее, медиану и размах. / Mean, median, range.',
      helper: 'Сортируй для медианы. / Sort for median.',
      answer: 'Среднее 8; медиана 8; размах 2.5. / Mean 8; median 8; range 2.5.', unit: '' },
    { id: 'q3', type: 'math', title: 'Проверка ошибок / Error check',
      prompt: 'Было 32 ошибки. Исправили 75%. Сколько исправлено и сколько осталось? / 75% of 32; remainder.',
      helper: '0.75 × 32; вычитание. / Multiply then subtract.',
      answer: 'Исправлено 24; осталось 8. / 24 fixed; 8 left.', unit: 'ошибок / errors' },
    { id: 'q4', type: 'math', title: 'Система ролей / Role equation',
      prompt: 'Редактор проверяет в 2 раза больше страниц, чем дизайнер; мастер — на 5 больше дизайнера. Всего 65 страниц. Найди страницы дизайнера. / Designer = x, editor = 2x, maker = x + 5; total 65.',
      helper: 'x + 2x + (x + 5) = 65. / Combine.',
      answer: '15 страниц у дизайнера. / 15 pages.', unit: 'страниц / pages' },
    { id: 'q5', type: 'classify', title: 'Части речи / Parts of speech',
      prompt: 'Распредели по частям речи. / Sort by part of speech.',
      categories: [
        { id: 'noun', label: 'Существительное / Noun' },
        { id: 'verb', label: 'Глагол / Verb' },
        { id: 'adj', label: 'Прилагательное / Adjective' }
      ],
      items: [
        { id: 'w1', text: 'команда / team' },
        { id: 'w2', text: 'внимательный / attentive' },
        { id: 'w3', text: 'проверять / to check' },
        { id: 'w4', text: 'роль / role' },
        { id: 'w5', text: 'дружный / friendly' },
        { id: 'w6', text: 'исправлять / to fix' }
      ] },
    { id: 'q6', type: 'text', title: 'Исправь ошибки / Fix mistakes',
      prompt: 'Перепиши без ошибок: «в команде разние роли, и все они важны для качиства проекта». / Rewrite without mistakes.',
      placeholder: 'В команде... / In a team...' },
    { id: 'q7', type: 'text', title: 'Главная мысль и план / Main idea and plan',
      prompt: 'Прочитай текст «Команда, роли и качество» на печатном листе. Запиши главную мысль, план из 3 пунктов и 4 предложения. / Read; main idea + plan + 4 sentences.',
      placeholder: 'Главная мысль: ... / Main idea: ...' },
    { id: 'q8', type: 'text', title: 'Логика: меньше задач ≠ хуже / Logic: fewer tasks ≠ worse',
      prompt: 'Если один участник сделал меньше задач, значит ли, что он хуже помогал? Какие ещё данные нужны? 2–4 предложения. / What other data?',
      placeholder: 'Меньше задач — не всегда... / Fewer tasks does not always...' },
    { id: 'q9', type: 'essay', title: 'Карточка команды из 3 ролей / Team card with 3 roles',
      prompt: 'Опиши команду из 3 ролей: кто, что делает, чем помогает проекту. Добавь одну проверку качества. / Team card + one quality check.',
      minSentences: 4, maxSentences: 8, placeholder: 'Роль 1: ... Роль 2: ... Роль 3: ... Проверка: ...' }
  ],
  notebookInstructions: [
    'Заголовок: «Неделя 7, День 4». / Heading.',
    'Слой 1. Математика: q1–q4. / Math.',
    'Слой 2. Русский: части речи + исправление. / Russian.',
    'Слой 3. Чтение: главная мысль + план + 4 предложения. / Reading.',
    'Слой 4. Логика: меньше задач ≠ хуже. / Logic.',
    'Слой 5. Практика: карточка команды 3 ролей. / Practical.',
    'Дневник мышления / Thinking diary.',
    'Награда нимами. / Reward.'
  ],
  printWorksheet: {
    title: 'Неделя 7, День 4 / Week 7, Day 4',
    subtitle: 'Команда, роли и качество / Team, Roles and Quality',
    pages: [
      { title: 'Маршрут дня: пять слоёв обучения / Daily route: five learning layers', blocks: [
        { type: 'list', items: [
          '1. Математика / Math — 30–35 мин / min.',
          '2. Русский язык / Russian — 15–20 мин / min.',
          '3. Чтение и письмо / Reading and writing — 10–15 мин / min.',
          '4. Логика и анализ данных / Logic and data analysis — 5–10 мин / min.',
          '5. Практика: карточка команды / Practical: team card — 10–15 мин / min.',
          '6. Дневник мышления / Thinking diary — 5 мин / min.',
          '7. Награда нимами / Reward in nims.'
        ] }
      ] },
      { title: 'Слой 1. Математика / Layer 1. Math', blocks: [
        { type: 'text', text: 'Grade 6: дроби, среднее/медиана/размах, проценты, уравнение. Показывай шаги. / Show steps.' },
        { type: 'list', items: [
          '1) 1/4 от 48 = ____ (дизайнер). 1/3 от 48 = ____ (мастер). Остаток редактора: 48 − ____ − ____ = ____. / Fractions.',
          '2) 7.5, 8, 9, 6.5, 9. Сумма = ____. Среднее = ____ ÷ 5 = ____. Сортировка: ____, ____, ____, ____, ____. Медиана = ____. Размах = 9 − ____ = ____. / Quality index.',
          '3) 75% × 32 = ____ (исправлено). 32 − ____ = ____ (осталось). / Fix percent.',
          '4) x + 2x + (x + 5) = 65. 4x + 5 = ____. 4x = ____. x = ____ (дизайнер). Редактор = ____; мастер = ____. / Equation.',
          '5) Проверка / Check: 12 + 16 + 20 = ____ = 48? / Verify fractions.',
          '6) Если у мастера 20 задач, а у дизайнера 12, отношение = ____:____. / Ratio check.',
          '7) Optional / Доп.: 25% × 32 = ____ = ошибки на 2 круге. / Extra %.',
          '8) Optional / Доп.: если общая оценка вырастет на 12.5%, новое среднее из 8 = ____. / Extra %.'
        ] }
      ] },
      { title: 'Слой 2. Русский язык и правописание / Layer 2. Russian Language and Spelling', blocks: [
        { type: 'text', text: 'Правило / Rule: части речи по вопросу; безударные проверяем ударением. / Parts of speech + unstressed.' },
        { type: 'list', items: [
          'Словарь / Vocabulary: команда, роль, дизайнер, мастер, редактор, качество, проверка, вклад.',
          'Части речи / Parts of speech: команда, внимательный, проверять, роль, дружный, исправлять — раздели.',
          'Исправь ошибки / Fix mistakes: «в команде разние роли, и все они важны для качиства проекта».',
          'Мини-диктант / Mini-dictation: «В команде разные роли, и все они важны для качества проекта».',
          'Орфограмма дня / Spelling rule: безударные + −тся/−ться. / Unstressed + −tsya.'
        ] }
      ] },
      { title: 'Слой 3. Чтение, письмо и пересказ / Layer 3. Reading, Writing and Retelling', blocks: [
        { type: 'list', items: [
          'Текст «Команда, роли и качество» / Text: Хорошая команда работает, когда каждая роль ясна: дизайнер оформляет, мастер делает, редактор проверяет. Иногда кажется, что человек с меньшим числом задач помогает меньше. На самом деле его роль может быть тише, но важнее — проверка ловит ошибки, которые видно только внимательному глазу. Поэтому качество измеряется не количеством, а вкладом в общий результат. Команда — это оркестр, где партии разные, но важна общая мелодия. / A good team works when each role is clear. A quieter role like checking may prevent big mistakes. Quality is measured by contribution, not by count. A team is an orchestra: different parts, one melody.',
          'Главная мысль / Main idea: __________________________________',
          'План из 3 пунктов / 3-point plan: 1) ______ 2) ______ 3) ______',
          '4 своих предложения о команде / 4 sentences: ______________________________',
          'Пересказ родителю 3–5 предложений по-русски / Retell in 3–5 Russian sentences ✓.'
        ] }
      ] },
      { title: 'Слой 4. Логика и анализ данных / Layer 4. Logic and Data Analysis', blocks: [
        { type: 'text', text: 'Данные: Аня — 10 задач, но нашла 12 ошибок; Боря — 25 задач, но не проверил ничего. / Data.' },
        { type: 'list', items: [
          'Кто помог больше и почему? / Who helped more and why?',
          'Какие 3 показателя нужны, чтобы честно сравнить? / 3 metrics for fair comparison.',
          'Мой аргумент / My argument: __________________________________',
          'Вывод / Conclusion: «меньше задач» — не «меньше помощи». Смотри вклад. / Fewer tasks ≠ less help.',
          'Проверка / Check: назови роль, которая ценна вкладом, а не количеством. / Name a role valued by contribution.'
        ] }
      ] },
      { title: 'Слой 5. Практические знания: карточка команды / Layer 5. Practical Knowledge: team card', blocks: [
        { type: 'text', text: 'Опиши команду из 3 ролей для учебного проекта. / 3-role team card for a learning project.' },
        { type: 'list', items: [
          'Роль 1 / Role 1: __________________________________ (что делает / does).',
          'Роль 2 / Role 2: __________________________________ (что делает / does).',
          'Роль 3 / Role 3: __________________________________ (что делает / does).',
          'Кто проверяет качество / Who checks quality: __________________________________',
          'Как проверяем 1 ошибку / One error-check: __________________________________',
          'Условная оценка команды 1–10 / Team score 1–10 (learning): ____.',
          'Вывод / Conclusion: __________________________________'
        ] }
      ] },
      { title: 'Дневник мышления / Thinking Diary', blocks: [
        { type: 'list', items: [
          'Что я понял про командную работу / What I learned about teamwork: ______',
          'Самое важное слово / Most important word: ______'
        ] }
      ] },
      { title: 'Родительская проверка и награда нимами / Parent check and reward in nims', blocks: [
        { type: 'list', items: [
          'Базовая награда / Base reward: 3 нима / nims ✓',
          'Бонус за дроби и уравнение / Bonus for fractions + equation: +1 ☐',
          'Бонус за карточку команды / Bonus for team card: +1 ☐',
          'Итого / Total: ____ из / of 5 нимов / nims'
        ] }
      ] }
    ]
  },
  parentGuide: {
    goal:
      'Grade 6: 1/4 × 48 = 12, 1/3 × 48 = 16, остаток 20; {6.5,7.5,8,9,9}: 8/8/2.5; 0.75 × 32 = 24 (осталось 8); x + 2x + (x+5) = 65 → x = 15. Русский Grade 3–4. / Solid Grade 6 + Grade 3–4 Russian.',
    mathGoal: 'q1: 20 (48 − 12 − 16). q2: 8/8/2.5. q3: 24 и 8. q4: x = 15 (15/30/20). / Listed with steps.',
    russianGoal: 'Существительные: команда, роль. Глаголы: проверять, исправлять. Прилагательные: внимательный, дружный. / Correct sorting.',
    readingWritingGoal: 'Главная мысль: качество измеряется вкладом, а не количеством. План + 4 предложения. / Main idea + plan + 4 sentences.',
    practicalGoal: 'Карточка команды из 3 ролей + одна проверка качества. / 3-role team card + one check.',
    check: [
      'Q1: редактор 20 задач.',
      'Q2: 8 / 8 / 2.5.',
      'Q3: 24 исправлено; 8 осталось.',
      'Q4: x = 15 (дизайнер).',
      'Части речи разобраны. / Parts of speech.',
      'Главная мысль + план + 4 предложения. / Main idea + plan + 4 sentences.',
      'Логика меньше задач ≠ хуже. / Fewer tasks ≠ worse.',
      'Карточка команды. / Team card.'
    ],
    answerKey: [
      { taskId: 'q1', answer: '1/4 × 48 = 12; 1/3 × 48 = 16; 48 − 12 − 16 = 20 (редактор). / 20 tasks.' },
      { taskId: 'q2', answer: 'Сумма 40; среднее 8; сортировка 6.5/7.5/8/9/9; медиана 8; размах 9 − 6.5 = 2.5.' },
      { taskId: 'q3', answer: '0.75 × 32 = 24 (исправлено); 32 − 24 = 8 (осталось).' },
      { taskId: 'q4', answer: 'x + 2x + (x + 5) = 65; 4x + 5 = 65; 4x = 60; x = 15. Дизайнер 15, редактор 30, мастер 20.' },
      { taskId: 'q5', answer: 'Существительные: команда, роль. Глаголы: проверять, исправлять. Прилагательные: внимательный, дружный.' },
      { taskId: 'q6', answer: 'В команде разные роли, и все они важны для качества проекта.' },
      { taskId: 'q7', answer: 'Главная мысль: качество через вклад, а не количество. План: 1) ясные роли; 2) тихий может ловить ошибки; 3) команда — оркестр. 4 предложения — открытый ответ.' },
      { taskId: 'q8', answer: '2–4 предложения: смотрим 3 показателя — количество, качество, вклад в проверку. Пример: 10 задач + 12 найденных ошибок против 25 задач без проверки. / 3 metrics.' },
      { taskId: 'q9', answer: 'Открытый ответ: 3 роли + 1 проверка качества. / Open answer.' }
    ],
    spellingCheck: 'Части речи + −тся/−ться правильно. / Parts of speech + −tsya.',
    readingCheck: 'Главная мысль ясная; план 3 пункта; 4 предложения; пересказ 3–5 предложений. / Main idea + plan + retelling.',
    notebookCheck: 'Все 5 слоёв заполнены. / All 5 layers.',
    printCheck: 'Все 8 страниц заполнены. / All 8 pages.',
    discussionPrompts: [
      'Что делает команду командой? / What makes a team a team?',
      'Как ты понимаешь, что вклад ценен? / How to see contribution?',
      'Какая роль тебе ближе? / Which role suits you?',
      'Что важнее — количество или проверка? / Count or check?'
    ],
    ifEasy: 'Усложни: пересчитай, если у мастера 1/2, а у дизайнера 1/6. / Extend: 1/2 and 1/6.',
    ifDifficult: 'Оставь q1 и q3. / Keep q1 and q3.',
    tokenReward:
      'После проверки можно начислить бонусные нимы через Parent Room. Нимы — это призовые токены курса, а не оплата. / Nims are course prize tokens, not payment.'
  },
  reward: {
    unit: 'nim', unitName: 'ним', base: 3, max: 5,
    label: 'Награда за завершение / Completion reward', display: '3 нима / 3 nims',
    bonuses: [
      { id: 'fractions-eq', label: 'Бонус за дроби и уравнение / Bonus for fractions + equation', amount: 1 },
      { id: 'team-card', label: 'Бонус за карточку команды / Bonus for team card', amount: 1 }
    ]
  },
  completionRequirements: { requiredTaskIds: ['q1', 'q4', 'q7', 'q9'], allowNotebookCompletion: true },
  unlockAfter: { weekId: 'week-7', dayId: 'day-3' },
  nextLessonId: 'max-week-7-day-5'
};

export default maxWeek7Day4;
